import React from 'react'

const ServicesTab = () => {
    return (
        <div className='row'>
            <label htmlFor="" className='form-label'>
                Services provided by this Organisation
            </label>
            <div className="col-md-4">
                <div className="form-check ">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault1"
                    >
                        Bank{" "}
                    </label>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-check ">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault2"
                    >
                        CFS (Container Freight Station)
                    </label>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-check ">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault3"
                    >
                        Container Provider
                    </label>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-check ">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault4"
                    >
                        Container Terminal Operator
                    </label>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-check ">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault5"
                    >
                        Container Yard
                    </label>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-check ">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault6"
                    >
                        Custom Broker
                    </label>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-check ">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault7"
                    >
                        Fumigation Contractor
                    </label>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-check ">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault8"
                    >
                        ICD (Inland Container Depo)
                    </label>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-check ">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault9"
                    >
                        Packing Depot
                    </label>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-check ">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault9"
                    >
                        UnPacking Depot
                    </label>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-check ">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault9"
                    >
                        Vendor
                    </label>
                </div>
            </div>
        </div>
    )
}

export default ServicesTab